import Swiper from 'swiper'

export default {
  gallerySwiper: undefined,

  init() {
    let obj = this

    /* Swiper gallery */
    if ($('.gallery.swiper-container').length > 0) {
      obj.gallerySwiper = new Swiper('.gallery.swiper-container', {
        direction: 'horizontal',
        speed: 500,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 0,
        threshold: 15,
        resistanceRatio: 0.15,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    }
  },

  kill() {
    //
  },
}
